import confetti from 'canvas-confetti';

/**
 * Celebración al marcar el primer pedido como enviado (cañones morados / blanco).
 */
export function celebrarPrimerEnvio() {
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 10050 };

  const randomInRange = (min, max) => Math.random() * (max - min) + min;

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      clearInterval(interval);
      return;
    }

    const particleCount = 50 * (timeLeft / duration);

    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      colors: ['#7c3aed', '#a855f7'],
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      colors: ['#ffffff', '#7c3aed'],
    });
  }, 250);
}

/** Confeti al completar el anillo de progreso de onboarding (verde + marca). */
export function dispararCelebracion() {
  confetti({
    particleCount: 150,
    spread: 80,
    origin: { y: 0.6 },
    colors: ['#22c55e', '#ffffff', '#7c3aed'],
  });
}
